import { UploadFile } from "../../ui/uploadFile";
import {TooltipComponent} from "../../ui/Tooltip"
import {QuestionIcon} from "../../../icons/questionIcon"
import { useEffect, useMemo, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import clsx from "clsx";
import { AddIcon } from "../../../icons/addIcon";

export const UploadFilesCard = ({ uploadCase, onChange, className, disabled, titleClassName='' }) => {
    const [uploadedFiles, setUploadedFiles] = useState([]);

    useEffect(() => {
        if (uploadCase) {
        setUploadedFiles(uploadCase.fileArray)
      }
    }, [uploadCase, uploadCase.fileArray])
    
    const addMore = useMemo(() => {
        return (uploadedFiles.findIndex(item => item === null) === -1) && uploadedFiles.length < uploadCase.maxFiles
    },[uploadedFiles])


    const handleUpload = (mode,file,index) => {
        let updateArray = [...uploadedFiles];
        if(mode === 'upload'){
            updateArray[index] = file;
        }
        onChange(updateArray,index)
    }

    const moreFilesClicked = () => {
        const newUploadedFiles = [...uploadedFiles];
        newUploadedFiles.push(null);
        setUploadedFiles(newUploadedFiles)
    }

    return (
            <div className={clsx("flex flex-col gap-5")}>
                <div className="flex w-full justify-between">
                    <div className="flex gap-2 flex-col">
                        <div className="flex gap-2 items-center">
                        <h4 className={clsx("max-lg:hidden w-9/12",titleClassName)}>{uploadCase.documentCodesToFriendlyNames}</h4>
                        <h5 className="lg:hidden">{uploadCase.documentCodesToFriendlyNames}</h5>
                            {uploadCase.helpButton && (uploadCase.helpButton.url !== '' ?
                            <QuestionIcon className={'cursor-pointer'} onClick={() => { window.open(uploadCase.helpButton.url) }} /> :
                            <TooltipComponent side="bottom" content={uploadCase.helpButton.helpContent === 'idInstructions'?
                                <div className="flex flex-col gap-2 items-center">
                                    <h6>Θα χρειαστεί να υποβάλεις αντίγραφο της αστυνομικής σου ταυτότητας.</h6>
                                    <img alt='' width={150} height={150} className={'rotate-90'} src="/avis/images/ID-Sample.jpg" />
                                </div>
                                : uploadCase.helpButton.helpContent === 'utilityBillInstructions' ? 
                                <div className="flex flex-col gap-2 max-lg:w-[50vw]">
                                  <p>Χρειαζόμαστε ένα έντυπο από έναν από τους παρακάτω φορείς:</p>
                                      <strong>Πάροχος Ηλεκτρικού Ρεύματος (π.χ. ΔΕΗ)</strong>
                                  <p>
                                    PDF ή Εικόνα ή
                                    <a href="https://ebill.dei.gr/Login.aspx?lang=1" target="_blank" className="text-underline" rel="noreferrer"
                                      >E-Bill της ΔΕΗ&nbsp;&nbsp;</a>
                                  </p>
                                      <strong>Πάροχος Ύδρευσης (π.χ. ΕΥΔΑΠ)</strong>
                                  <p>PDF ή Εικόνα</p>
                                      <strong>Πάροχος Σταθερής Τηλεφωνίας (π.χ. ΟΤΕ)</strong>
                                  <p>PDF ή Εικόνα</p>
                                    </div> :
                                    <p>{uploadCase.helpButton.helpContent}</p>    
                                }>
                                <div>
                                    <QuestionIcon className={'cursor-pointer'}/>
                                </div>
                            </TooltipComponent>
                            )}
                        </div>
                    </div> 
                    {addMore &&
                        <div className="flex items-center">
                        <h4 className="max-lg:hidden">Προαιρετική Προσθήκη Αρχείου</h4>
                        <AddIcon onClick={moreFilesClicked} className={'bg-[#D4002A] rounded-full cursor-pointer w-6 h-6'}/>
                        </div>}
                </div>
                <div className="lg:grid lg:grid-cols-2 lg:gap-4">
                {uploadedFiles.map((file, index) => <UploadFile className={className} disabled={disabled} maxFiles={uploadCase.maxFiles} canDelete={false} prevFile={file} itemIndex={uuidv4()} key={index} onFileChange={(mode,file)=>{handleUpload(mode,file,index)}} allowedTypes={uploadCase.documentAllowedTypes}/>)}
                </div>
            </div>
    )
}